import { NgModule } from '@angular/core';
import { PreloadAllModules, RouterModule, Routes } from '@angular/router';
import { AuthGuard } from './auth/auth.guard';
// import { AnimateGuard } from './auth/animate.guard';

const routes: Routes = [
  {
    path: '',
    redirectTo: 'accounts',
    pathMatch: 'full',
  },
  {
    path: 'onboarding',
    loadChildren: () => import('./onboarding/onboarding.module').then((m) => m.OnboardingPageModule),
  },
  {
    path: 'reset-password',
    loadChildren: () => import('./accounts/reset-password/reset-password.module').then((m) => m.ResetPasswordPageModule),
  },
  {
    path: 'order',
    loadChildren: () => import('./order/order.module').then((m) => m.OrderPageModule),
  },
  {
    path: 'calendar',
    canActivate: [AuthGuard],
    loadChildren: () => import('./calendar/calendar.module').then((m) => m.CalendarPageModule),
  },
  {
    path: 'meal-preferences',
    canActivate: [AuthGuard],
    loadChildren: () => import('./meal-preferences/meal-preferences.module').then((m) => m.MealPreferencesPageModule),
  },
  {
    path: 'menu',
    canActivate: [AuthGuard],
    loadChildren: () => import('./menu/menu.module').then((m) => m.MenuPageModule),
  },
  {
    path: 'dashboard',
    canActivate: [AuthGuard],
    loadChildren: () => import('./my-health/my-health.module').then((m) => m.MyHealthPageModule),
  },
  {
    path: 'notifications',
    canActivate: [AuthGuard],
    loadChildren: () => import('./notifications/notifications.module').then((m) => m.NotificationsPageModule),
  },
  {
    path: 'community',
    loadChildren: () => import('./community/community.module').then((m) => m.CommunityPageModule),
  },
  {
    path: 'accounts',
    canActivate: [AuthGuard],
    loadChildren: () => import('./accounts/accounts.module').then((m) => m.AccountsPageModule),
  },
  {
    path: 'journey',
    loadChildren: () => import('./journey/journey.module').then((m) => m.JourneyPageModule),
  },
  {
    path: 'journey-result',
    loadChildren: () => import('./journey/journey-result/journey-result.module').then((m) => m.JourneyResultPageModule),
  },
  {
    path: 'profile',
    canActivate: [AuthGuard],
    loadChildren: () => import('./accounts/profile/profile.module').then((m) => m.ProfilePageModule),
  },
  {
    path: 'loyalty',
    canActivate: [AuthGuard],
    loadChildren: () => import('./accounts/loyalty/loyalty.module').then((m) => m.LoyaltyPageModule),
  },
  {
    path: 'news',
    loadChildren: () => import('./accounts/news/news.module').then((m) => m.NewsPageModule),
  },
  {
    path: 'consultation',
    canActivate: [AuthGuard],
    loadChildren: () => import('./accounts/consultation/consultation.module').then((m) => m.ConsultationPageModule),
  },
  {
    path: 'celebrity',
    // canActivate: [AuthGuard],
    loadChildren: () => import('./celebrity/celebrity.module').then((m) => m.CelebrityPageModule),
  },
  {
    path: 'celebrity-subscription',
    // canActivate: [AuthGuard],
    loadChildren: () => import('./celebrity-subscription/celebrity-subscription.module').then((m) => m.CelebritySubscriptionPageModule),
  },
  {
    path: 'new-consultation',
    loadChildren: () => import('./accounts/consultation/new-consultation/new-consultation.module').then((m) => m.NewConsultationPageModule),
  },
  {
    path: 'change-password',
    canActivate: [AuthGuard],
    loadChildren: () => import('./accounts/change-password/change-password.module').then((m) => m.ChangePasswordPageModule),
  },
  {
    path: 'address-lists',
    canActivate: [AuthGuard],
    loadChildren: () => import('./accounts/address-lists/address-lists.module').then((m) => m.AddressListsPageModule),
  },
  {
    path: 'my-subscriptions',
    canActivate: [AuthGuard],
    loadChildren: () => import('./accounts/my-subscriptions/my-subscriptions.module').then((m) => m.MySubscriptionsPageModule),
  },
  {
    path: 'upgrade-subscription',
    canActivate: [AuthGuard],
    loadChildren: () => import('./accounts/upgrade-subscription/upgrade-subscription.module').then((m) => m.UpgradeSubscriptionPageModule),
  },
  {
    path: 'subscription-list',
    loadChildren: () => import('./accounts/subscription-list/subscription-list.module').then((m) => m.SubscriptionListPageModule),
  },
  // {
  //   path: 'subscription-list',
  //   canActivate: [AuthGuard],
  //   loadChildren: () => import('./celebrity/celebrity.module').then((m) => m.CelebrityPageModule),
  // },
  {
    path: 'checkout',
    canActivate: [AuthGuard],
    loadChildren: () => import('./accounts/checkout/checkout.module').then((m) => m.CheckoutPageModule),
  },
  {
    path: 'checkout-pending',
    canActivate: [AuthGuard],
    loadChildren: () => import('./accounts/checkout-pending/checkout-pending.module').then((m) => m.CheckoutPendingPageModule),
  },
  {
    path: 'settings',
    canActivate: [AuthGuard],
    loadChildren: () => import('./accounts/settings/settings.module').then((m) => m.SettingsPageModule),
  },
  {
    path: 'customer-details',
    loadChildren: () => import('./order/customer-details/customer-details.module').then((m) => m.CustomerDetailsPageModule),
  },
  {
    path: 'order-checkout',
    loadChildren: () => import('./order/order-checkout/order-checkout.module').then((m) => m.OrderCheckoutPageModule),
  },
  {
    path: 'order-confirm/:id',
    loadChildren: () => import('./order/order-confirmed/order-confirmed.module').then((m) => m.OrderConfirmedPageModule),
  },
  {
    path: 'order-failed/:id',
    loadChildren: () => import('./order/order-failed/order-failed.module').then((m) => m.OrderFailedPageModule),
  },
  {
    path: 'order-history',
    loadChildren: () => import('./order/order-history/order-history.module').then((m) => m.OrderHistoryPageModule),
  },
  {
    path: 'order-details/:id',
    loadChildren: () => import('./order/order-details/order-details.module').then((m) => m.OrderDetailsPageModule),
  },
  {
    path: 'menu-list',
    loadChildren: () => import('./menu-list/menu-list.module').then((m) => m.MenuListPageModule),
  },
];
@NgModule({
  imports: [
    RouterModule.forRoot(routes, {
      preloadingStrategy: PreloadAllModules,
    }),
  ],
  exports: [RouterModule],
})
export class AppRoutingModule {}
